import type { IconSvgObject } from './types';

const SignalMedium02Icon: IconSvgObject = [
  ["path", { d: "M21 19L18 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 14H4C3.44772 14 3 14.4477 3 15V18C3 18.5523 3.44772 19 4 19H6C6.55228 19 7 18.5523 7 18V15C7 14.4477 6.55228 14 6 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 10H11C10.4477 10 10 10.4477 10 11V18C10 18.5523 10.4477 19 11 19H13C13.5523 19 14 18.5523 14 18V11C14 10.4477 13.5523 10 13 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default SignalMedium02Icon;
